<template>
    <div style="padding:1px;">
        <hd></hd>
        <div class="snatched" style="display: flex;flex-direction: column;align-items: center;">
          <!--<el-input style="margin-bottom:10px;width:450px;" v-model="url" placeholder="请输入App页面">
          </el-input>-->
          <el-select style="width:200px;" @change="urlChange" v-model="url" class="input-width" placeholder="请选择App页面">
            <el-option v-for="(item,index) in APPPages" :key="index" :label="item.name" :value="item.url"></el-option>
          </el-select>
          <div v-if="query" style="margin-top:10px;">
            <label>{{ desc }}</label>
            <el-input style="margin-bottom:10px;width:150px;" v-model="queryid" placeholder="">
            </el-input>
          </div>
          <div  style="margin-top:10px;">
            <el-button class="nohover" type="info" style="width:200px;" @click="generate()">生成短链接</el-button>
          </div>
          <p v-if="shortUrl" style="margin-top:10px;">
            {{ shortUrl }}
            <span style="margin-left:5px;cursor: pointer;" v-clipboard:copy="shortUrl" v-clipboard:success="onCopy">
                <i v-if="!copyTxtSuccess" class="el-icon-news"></i> {{copyTxtSuccess?'已复制':'复制'}}
            </span>
        </p>
        </div>
        <ft></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

import { BASE_HOST, APPPages } from '../../services/constant'

export default {
  name: 'SearchCode',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
        url:'',
        shortUrl:'',
        APPPages:APPPages,
        desc:'',
        query:null,
        queryid:'',
        copyTxtSuccess:false
    }
  },
  mounted () {
    
  },
  methods: {
    onCopy (e) {
      this.copyTxtSuccess = true
      setTimeout(() => {
        this.copyTxtSuccess = false
      }, 2000)
    },
    urlChange(e){
       let page = this.APPPages.find(i=>i.url==e);
       this.query = page.query;
       if(this.query){
        switch(page.name){
            case '商品详情':
                this.desc = '商品id：'
                break;
            case '帖子详情':
                this.desc = '帖子id：'
                break;
        }
       }
    },
    async generate(){
        if(this.url=='')
            return;
        let u = this.url
        if(this.desc == '商品id：')
            u = u + '?pid='+ this.queryid;
        else
            u = u + '?id='+ this.queryid;
        let res = await api.generateShortUrl(this, {
            long_url:'https:'+BASE_HOST+'/appredirect?u='+u,
            expire_hours:24
        })
        if (res.body.status == 'ok') {
            this.shortUrl = res.body.result.short_url
        }
    },
  },
}

</script>
<style scoped lang="scss">
    @font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  /* Color fonts */
  src:
       url('../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
    .el-icon-joyordercopy-document:before {
        content: "\e64a";
    }
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
    text-align: center;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrCode/appshorturl.vue